import { ReactNode } from 'react';
import classes from 'classnames';
import CloseIcon from 'assets/icons/close.svg?react';
import styles from './Notification.module.scss';

export type Props = {
  children: ReactNode;
  onClose?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  dataTest?: string;
  type?: 'warning' | 'error';
  className?: string;
};

function Notification({
  children,
  onClose,
  dataTest = 'notification',
  type = 'error',
  className,
}: Props) {
  return (
    <div
      className={classes(styles.container, styles[type], className)}
      data-test={dataTest}
    >
      {children}
      {onClose && (
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          data-test={`${dataTest}-close-btn`}
        >
          <CloseIcon
            className={styles.icon}
            data-test={`${dataTest}-close-icon`}
          />
        </button>
      )}
    </div>
  );
}

export default Notification;
